export default {
  shops: [],
  shop: undefined,
};
